export default __webpack_public_path__ + "static/media/leaf_sheet.186f13e7.png";